export default __webpack_public_path__ + "static/hello1-bcf1fcd6fdb32336a4cf49bfc4feb258.mp4";